import { MapFeature } from './map-feature'
import { isDeepEqual, isSameScale } from './compare'

export const PrimaryMap = ({ projection, mapRegionInfo, regionData, scale, isLayerEnabled, valueLabel, enableZoom, isZoomedIn, showSelected, valueType, value2Type, width, height }) => {
  return projection.features.map(({ feature }, i) => {
    const regionInfo = mapRegionInfo(feature)
    const data = regionData[regionInfo.code] || {}
    regionInfo.value = data.value
    regionInfo.value2 = data.value2
    regionInfo.valueLabel = valueLabel
    return (
      <MapFeature
        key={`feature-${regionInfo.code !== undefined ? regionInfo.code : i}`}
        pathDefinition={projection.path(feature)}
        color={scale(regionInfo.value)}
        isSelected={false}
        showOutline={!isLayerEnabled || isZoomedIn}
        isZoomedIn={isZoomedIn}
        onMouseOver={() => {
          if (!enableZoom || isZoomedIn) {
            showSelected(feature, regionInfo, valueType, value2Type)
          }
        }}
      />
    )
  })
}

export const arePrimaryMapsEqual = (prev, next) => {
  return (prev.enableZoom === next.enableZoom) &&
    (prev.isZoomedIn === next.isZoomedIn) &&
    (prev.valueLabel === next.valueLabel) &&
    (prev.valueType === next.valueType) &&
    (prev.value2Type === next.value2Type) &&
    (prev.width === next.width) &&
    (prev.height === next.height) &&
    isSameScale(prev.scale, next.scale) &&
    isDeepEqual(prev.regionData, next.regionData)
}
